import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useParams } from "react-router-dom";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";

const SoundLogBookViewList = () => {
  const { soundingLog_id } = useParams();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [staff_dashboard, set_staff_dashboard] = useState([]);

  const LIST_SUB_TANKS_API = () => {
    try {
      set_page_loader(true);
      const FORM_DATA = new FormData();
      const staff_Details = JSON.parse(localStorage.getItem("user_data"));
      FORM_DATA.append("ship_id", staff_Details?.data?.ship_details?.ship_id);
      FORM_DATA.append("sound_log_book_id", atob(soundingLog_id));
      post(ApiURL.list_tank_updates_sound_log_book, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_page_loader(false);
          setFilteredData(res?.tank_updates);
        }
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    LIST_SUB_TANKS_API();
  }, []);

  const columns = [
    {
      title: "Tanks Id",
      dataIndex: "id",
      align: "center",
      key: "id",
    },
    {
      title: "Tanks Name",
      dataIndex: "tank_name",
      align: "center",
      key: "tank_name",
    },
    {
      title: "Tanks Category",
      dataIndex: "category_name",
      align: "center",
      key: "category_name",
    },
    {
      title: "Capacity (m3)",
      dataIndex: "capacity",
      align: "center",
      key: "capacity",
    },
    {
      title: "Remain On Board",
      dataIndex: "rob",
      align: "center",
      key: "rob",
    },
    {
      title: "Created Date",
      dataIndex: "log_date_time",
      align: "center",
      key: "log_date_time",
      render: (text, record) => {
        if (!record?.log_date_time) return "";
        const date = new Date(record.log_date_time);
        return date.toISOString().slice(0, 19).replace("T", " ");
      },
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (text, record) => {
        if (!record?.updated_at) return "";
        const date = new Date(record.updated_at);
        return date.toISOString().slice(0, 19).replace("T", " ");
      },
    },
  ];

  // ✅ Grouping Function
  const groupByCategoryWithSubtotals = (data = []) => {
    const grouped = {};

    data.forEach((item) => {
      const category = item.category_name || "Unknown";

      if (!grouped[category]) grouped[category] = [];

      grouped[category].push({
        ...item,
        _isSubtotal: false,
      });
    });

    // ✅ Add subtotal rows per category
    Object.entries(grouped).forEach(([category, items]) => {
      const totalRob = items.reduce(
        (sum, item) => sum + parseFloat(item.rob || 0),
        0
      );

      grouped[category].push({
        id: "",
        tank_name: "",
        category_name: "",
        capacity: "",
        rob: totalRob.toFixed(2),
        comment: "",
        _isSubtotal: true,
        vcf: "Total",
      });
    });

    return grouped;
  };
  const groupedData = groupByCategoryWithSubtotals(filteredData);

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      {Object.entries(groupedData).map(([category, items]) => (
        <div key={category} style={{ marginBottom: "30px" }}>
          <h4
            style={{
              fontWeight: "bold",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            Tank Category Name: {category}
          </h4>

          <Table
            bordered
            columns={columns}
            dataSource={items}
            pagination={false}
            rowKey={(record, index) => record.id || index}
            loading={page_loader}
            className="custom-table"
            rowClassName={(record) =>
              record._isSubtotal ? "subtotal-row" : ""
            }
          />
        </div>
      ))}
    </>
  );
};

export default SoundLogBookViewList;
